import { useMutation } from "@tanstack/react-query";
import { api, type ApiError } from "../lib/api";

export interface PylonSsoUrlResponse {
  url: string;
}

export function usePylonSsoUrl() {
  return useMutation<PylonSsoUrlResponse, ApiError, void>({
    mutationFn: () => api.post<PylonSsoUrlResponse>("/auth/pylon/sso-url"),
    retry: false,
  });
}

export default usePylonSsoUrl;
